<template>
  <spinner v-if="loading"></spinner>
  <section class="my-6 text-center" v-if="!loading && !listExists">
    <h2 class="h3">{{ noListMessage }}</h2>
    <a href="/" class="btn text-decoration-underline mt-4"> Til forsiden </a>
  </section>
  <section class="single-wishlist" v-if="!loading && listExists">
    <div>
      <h1>
        {{ wishlist.name }}
        <small v-if="favoriteText">{{ favoriteText }}</small>
      </h1>

      <button
        type="button"
        class="btn text-decoration-underline mt-4"
        @click="closeList"
        v-if="!wishlist.documents.length"
      >
        Til oversigten
      </button>
      <template v-for="(document, index) in wishlist.documents" :key="index">
        <article v-if="document.documentTypeAlias === 'PageTravel'">
          <div class="ratio ratio-16x9">
            <picture>
              <img
                class="img-fit"
                :src="document.image"
                :alt="document.imageAltText"
              />
            </picture>
          </div>
          <div>
            <span class="h6 text-secondary">Rejser</span>
            <span class="fw-bold d-block">{{ document.label }}</span>
            <h2>{{ document.title }}</h2>
            <p>{{ document.numberOfDays }} dage fra {{ document.fromPrice }}</p>
            <a :href="document.url">Se rejse</a>
          </div>
        </article>

        <article v-if="document.documentTypeAlias === 'PageHotel'">
          <div class="ratio ratio-16x9">
            <picture>
              <img
                class="img-fit"
                :src="document.image"
                :alt="document.imageAltText"
              />
            </picture>
          </div>
          <div>
            <span class="h6 text-secondary">Hoteller</span>
            <span class="fw-bold d-block">{{ document.label }}</span>
            <h2>{{ document.title }}</h2>
            <div class="star-container" v-if="document.showStars">
              <span
                class="icon-star"
                v-for="(star, index) in document.stars"
                :key="index"
              ></span>
              <span class="icon-plus" v-if="document.addPlusSignToStars"></span>
            </div>
            <a :href="document.url">Se hotel</a>
          </div>
        </article>

        <article v-if="document.documentTypeAlias === 'PageExperience'">
          <div class="ratio ratio-16x9">
            <picture>
              <img
                class="img-fit"
                :src="document.image"
                :alt="document.imageAltText"
              />
            </picture>
          </div>
          <div>
            <span class="h6 text-secondary">Oplevelser</span>
            <span class="fw-bold d-block">{{ document.label }}</span>
            <h2>{{ document.title }}</h2>
            <a :href="document.url">Se oplevelse</a>
          </div>
        </article>

        <article v-if="document.documentTypeAlias === 'PageBlog'">
          <div class="ratio ratio-16x9">
            <picture>
              <img
                class="img-fit"
                :src="document.image"
                :alt="document.imageAltText"
              />
            </picture>
          </div>
          <div>
            <span class="h6 text-secondary">Blogindlæg</span>
            <span class="fw-bold d-block">{{ document.label }}</span>
            <h2>{{ document.title }}</h2>
            <a :href="document.url">Se blogindlæg</a>
          </div>
        </article>
      </template>
    </div>
  </section>
</template>
<script>
import Spinner from "./components/Spinner.vue";
export default {
  name: "PublicWishlistApp",
  components: {
    Spinner,
  },
  data() {
    return {
      loading: true,
      wishlist: undefined,
      listExists: true
    };
  },
  computed: {
    favoriteText() {
      if (this.favoriteCount === 0) return "Listen har ikke nogen favoritter";

      return this.favoriteCount > 1
        ? "Listen har " + this.favoriteCount + " favoritter"
        : "Listen har 1 favorit";
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init: function () {
      const params = new Proxy(
        new URLSearchParams(decodeURI(window.location.hash.split("?")[1])),
        {
          get: (searchParams, prop) => searchParams.get(prop),
        }
      );

      if (params.publicListId) {
        this.$store
          .dispatch("getPublicWishlist", params.publicListId)
          .then((result) => {
            if (result.status) {
              this.listExists = false;
              this.noListMessage = result.data.Message;
              this.loading = false;
            } else if (result.id) {
              this.favoriteCount = result.documents.length;
              this.wishlist = result;
              this.loading = false;
            }
          });
      }
    },
  },
};
</script>